// extracted by mini-css-extract-plugin
export default {"root":"ContentHolder__root--qZpKh"};